<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<style lang="scss">
*{
  list-style: none;
  margin: 0;
  padding: 0;
}
body,html{
  width: 100%;
  height: 100%;
  // background-color: white;
  background: linear-gradient((#ffa6c8, 0, 0),rgb(4, 146, 255));

}
#app{
  height: 100%;
  background: linear-gradient((#ffb8d3, 0, 0),rgb(4, 146, 255));
}
</style>
